import React, { useEffect, useRef, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L, { latLngBounds } from 'leaflet';
import _ from 'lodash';

import { BasicText } from '../Styles';
import { TouchableOpacity, View } from 'react-native';
import { getHost, isMobile } from '../WasteApp';

const defaults = {zoomIn: 14, zoomOut: 6};

const UpdateMap = ({ markers }) => {
    const map = useMap();

    let markerBounds = latLngBounds([]);
    _.forEach(markers, (marker) => {
        markerBounds.extend([marker[0], marker[1]]);
    });

    markerBounds.isValid() && map.fitBounds(markerBounds);

    return null;
}

const WebMap = ({ markers, height = "100%", width = "100%", onClickEvent = undefined }) => {
    const [mapMarkers, setMapMarkers] = useState([]);
    const [mapProps, setMapProps] = useState( null );
    const host = getHost();

    const icon = new L.Icon({
        iconUrl: host + '/assets/images/marker.png',
        iconSize: new L.Point(33, 45),
        className: 'site-icon'
    });

    useEffect(()=>{
        if (markers != undefined) {
            setMapMarkers( _.map(_.filter(markers, (m) => m[0] != undefined), (m, i) => {
                return <Marker position={[parseFloat(m[0]), parseFloat(m[1])]} icon={icon} key={i}>
                    <Popup>
                        <TouchableOpacity onPress={onClickEvent != undefined? ()=>onClickEvent(m) : null}><BasicText style={{textDecoration: "underline"}}>{m[2]}</BasicText></TouchableOpacity>
                    </Popup>
                </Marker>;
            }) );

            const firstMarker = _.find(markers, (m) => m != undefined && m[0] != undefined);

            if(firstMarker != undefined && mapProps == null){
                setMapProps( {center: [firstMarker[0], firstMarker[1]], zoom: defaults.zoomOut } );
            }
        }
    }, [markers]);

    if (isMobile()) {
        return <BasicText>Insert Map Here</BasicText>;
    }

    if( _.isEmpty(mapMarkers) ){
        return null;
    }
    
    return <View style={{flexGrow: 15, height: height, width: width}}>
        <MapContainer center={mapProps.center} zoom={mapProps.zoom} scrollWheelZoom={false} style={{height: "100%", width: "100%"}} >
            <UpdateMap markers={markers} />
            <TileLayer
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png?api_key=51b1b016-c42d-41b5-99c6-cd94eabbd507"
            />
            {mapMarkers}
        </MapContainer>
    </View>;
};

export default WebMap;